var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFightRoom(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 300,
    height: 250,
    viewBox: "0 0 300 250",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1844_6843)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M139.231 208.365L0 127.981L160.769 35.1597L300 115.544L139.231 208.365Z",
    fill: "#D6403C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.253 195.877L22.9442 128.327L160.961 49.0884L278.27 116.639L140.253 195.877Z",
    fill: "#F3C69D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.231 208.365V249.629L0 169.245V127.98L139.231 208.365Z",
    fill: "#BE352D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300 115.544L139.231 208.365V249.629L300 156.808V115.544Z",
    fill: "#AD2825"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.801 50.1154L164.309 17.4976L163.31 19.228L219.735 51.8061C220.081 51.2331 220.45 50.6771 220.801 50.1154Z",
    fill: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.63 48.3111C217.541 48.2664 217.441 48.246 217.342 48.252C217.242 48.258 217.146 48.2901 217.063 48.3452C216.86 48.4883 216.7 48.6837 216.6 48.9105C216.501 49.1374 216.464 49.3872 216.495 49.6331C216.5 49.7512 216.541 49.865 216.613 49.9586C216.685 50.0522 216.785 50.1209 216.898 50.1551V50.1891L272.579 82.336L273.578 80.6339L217.63 48.3111Z",
    fill: "#AD2825"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.801 60.6513L164.309 28.0334L163.31 29.7639L219.735 62.342C220.081 61.7747 220.45 61.213 220.801 60.6513Z",
    fill: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.63 58.8187C217.541 58.774 217.441 58.7536 217.342 58.7596C217.242 58.7655 217.146 58.7977 217.063 58.8528C216.86 58.9958 216.7 59.1913 216.6 59.4181C216.501 59.645 216.464 59.8947 216.495 60.1407C216.498 60.2598 216.539 60.3749 216.611 60.4696C216.684 60.5643 216.784 60.6338 216.898 60.6683V60.7024L272.579 92.8493L273.578 91.1188L217.63 58.8187Z",
    fill: "#AD2825"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.801 71.1134L164.309 38.4956L163.31 40.2261L219.735 72.8042C220.081 72.2368 220.45 71.6808 220.801 71.1134Z",
    fill: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.63 69.3036C217.541 69.2589 217.441 69.2385 217.342 69.2444C217.242 69.2504 217.146 69.2825 217.063 69.3376C216.86 69.4807 216.7 69.6761 216.6 69.903C216.501 70.1298 216.464 70.3796 216.495 70.6255C216.498 70.7446 216.539 70.8597 216.611 70.9544C216.684 71.0491 216.784 71.1187 216.898 71.1532V71.1532L272.579 103.306L273.578 101.575L217.63 69.3036Z",
    fill: "#AD2825"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.9543 53.826L160.581 15.9714L161.58 17.6735L96.0209 55.5168C95.6748 54.9437 95.306 54.3877 94.9543 53.826Z",
    fill: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.2549 53.3152C99.2859 53.0693 99.2496 52.8195 99.1496 52.5927C99.0497 52.3658 98.8899 52.1704 98.6875 52.0273C98.6043 51.9723 98.508 51.9401 98.4084 51.9341C98.3088 51.9281 98.2093 51.9486 98.1201 51.9933L29.9398 91.5216V93.8308L98.8634 53.8713V53.8372C98.9744 53.8011 99.0716 53.7315 99.1417 53.6381C99.2117 53.5447 99.2513 53.432 99.2549 53.3152Z",
    fill: "#2C98DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.9543 64.3619L161.081 26.1838L162.079 27.9143L96.0209 66.0526C95.6748 65.4852 95.306 64.9292 94.9543 64.3619Z",
    fill: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.1258 62.5294C98.215 62.4847 98.3144 62.4643 98.4141 62.4703C98.5137 62.4762 98.6099 62.5084 98.6932 62.5634C98.8956 62.7065 99.0553 62.9019 99.1553 63.1288C99.2552 63.3557 99.2916 63.6054 99.2605 63.8514C99.2573 63.9705 99.2167 64.0855 99.1444 64.1802C99.072 64.275 98.9717 64.3445 98.8577 64.379V64.4131L29.9796 104.208L28.981 102.506L98.1258 62.5294Z",
    fill: "#2C98DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.9543 74.8242L160.581 37.0037L161.58 38.7058L96.0209 76.4923C95.6748 75.9476 95.306 75.3916 94.9543 74.8242Z",
    fill: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.1258 72.9916C98.215 72.9468 98.3144 72.9264 98.414 72.9324C98.5137 72.9384 98.6099 72.9705 98.6932 73.0256C98.8956 73.1687 99.0553 73.3641 99.1552 73.591C99.2552 73.8178 99.2916 74.0676 99.2605 74.3135C99.2573 74.4326 99.2166 74.5477 99.1443 74.6424C99.072 74.7371 98.9717 74.8067 98.8577 74.8412V74.8752L29.4803 115.022L28.4817 113.291L98.1258 72.9916Z",
    fill: "#2C98DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.8775 90.7556H17.5316V92.7527H29.8775V90.7556Z",
    fill: "#69CAFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.8775 112.384H17.5316V114.381H29.8775V112.384Z",
    fill: "#69CAFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.8775 101.57H17.5316V103.567H29.8775V101.57Z",
    fill: "#69CAFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.3738 116.826C31.71 116.826 28.7144 116.77 28.7144 119.447C28.7144 122.483 32.3738 122.483 32.3738 122.483V116.826Z",
    fill: "#69CAFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.3739 84.3899H28.7144V119.652H32.3739V84.3899Z",
    fill: "#69CAFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.3738 81.7857C31.71 81.7857 28.7144 81.729 28.7144 84.4013C28.7144 87.4424 32.3738 87.4424 32.3738 87.4424V81.7857Z",
    fill: "#8FDFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.691 79.3857H273.345V81.3829H285.691V79.3857Z",
    fill: "#EA5959"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.691 101.014H273.345V103.011H285.691V101.014Z",
    fill: "#EA5959"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.691 90.1997H273.345V92.1968H285.691V90.1997Z",
    fill: "#EA5959"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.849 105.456C271.518 105.456 274.514 105.399 274.514 108.072C274.514 111.113 270.849 111.113 270.849 111.113V105.456Z",
    fill: "#EA5959"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.854 108.282H274.514V73.02H270.854V108.282Z",
    fill: "#EA5959"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.849 70.4044C271.518 70.4044 274.514 70.3476 274.514 73.0199C274.514 76.061 270.849 76.061 270.849 76.061V70.4044Z",
    fill: "#F97878"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.743 144.888H135.719C135.293 144.888 134.948 145.233 134.948 145.66V183.372C134.948 183.798 135.293 184.144 135.719 184.144H142.743C143.17 184.144 143.515 183.798 143.515 183.372V145.66C143.515 145.233 143.17 144.888 142.743 144.888Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.4139 124.1L30.9157 91.4875L29.9172 93.1896L86.3473 125.768C86.6764 125.223 87.0565 124.667 87.4139 124.1Z",
    fill: "#69CAFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.2424 122.273C84.1537 122.227 84.0545 122.206 83.9549 122.211C83.8553 122.216 83.7588 122.247 83.675 122.301C83.4726 122.446 83.313 122.642 83.2131 122.87C83.1132 123.098 83.0768 123.348 83.1077 123.595C83.1121 123.713 83.1532 123.827 83.2255 123.92C83.2977 124.014 83.3973 124.083 83.5105 124.117V124.151L139.192 156.298L140.19 154.596L84.2424 122.273Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.4139 134.641L30.9157 102.024L29.9398 103.754L86.37 136.332C86.6764 135.759 87.0565 135.203 87.4139 134.641Z",
    fill: "#69CAFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.2424 132.809C84.1532 132.764 84.0538 132.744 83.9541 132.75C83.8545 132.756 83.7583 132.788 83.675 132.843C83.4726 132.986 83.3128 133.181 83.2129 133.408C83.113 133.635 83.0766 133.885 83.1077 134.131C83.1121 134.249 83.1533 134.363 83.2255 134.456C83.2977 134.55 83.3973 134.618 83.5105 134.653V134.687L139.192 166.839L140.19 165.109L84.2424 132.809Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.4139 145.104L30.9157 112.486L29.9398 114.216L86.37 146.794C86.6764 146.221 87.0565 145.665 87.4139 145.104Z",
    fill: "#69CAFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.2424 143.271C84.1532 143.226 84.0538 143.206 83.9541 143.212C83.8545 143.218 83.7583 143.25 83.675 143.305C83.4726 143.448 83.3128 143.644 83.2129 143.87C83.113 144.097 83.0766 144.347 83.1077 144.593C83.1121 144.711 83.1533 144.825 83.2255 144.919C83.2977 145.012 83.3973 145.081 83.5105 145.115V145.149L139.192 177.302L140.19 175.571L84.2424 143.271Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.219 115.504L272.846 77.6553L273.844 79.3574L208.285 117.195C207.939 116.622 207.571 116.066 207.219 115.504Z",
    fill: "#EA5959"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.39 113.672C210.48 113.627 210.579 113.606 210.679 113.612C210.778 113.618 210.874 113.65 210.958 113.706C211.16 113.849 211.32 114.044 211.42 114.271C211.52 114.498 211.556 114.748 211.525 114.993C211.521 115.112 211.479 115.225 211.407 115.319C211.335 115.413 211.235 115.481 211.122 115.515V115.549L140.23 156.678L139.231 154.947L210.39 113.672Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.219 126.04L273.339 87.8621L274.338 89.5925L208.285 127.742C207.939 127.175 207.571 126.607 207.219 126.04Z",
    fill: "#EA5959"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.39 124.208C210.48 124.163 210.579 124.143 210.679 124.148C210.778 124.154 210.874 124.187 210.958 124.242C211.16 124.385 211.32 124.58 211.42 124.807C211.52 125.034 211.556 125.284 211.525 125.53C211.522 125.649 211.481 125.764 211.409 125.858C211.337 125.953 211.236 126.023 211.122 126.057V126.091L142.244 165.881L141.246 164.178L210.39 124.208Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.219 136.502L272.846 98.6819L273.844 100.384L208.285 138.17C207.939 137.626 207.571 137.07 207.219 136.502Z",
    fill: "#EA5959"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.39 134.67C210.48 134.625 210.579 134.605 210.679 134.611C210.778 134.617 210.874 134.649 210.958 134.704C211.16 134.847 211.32 135.042 211.42 135.269C211.52 135.496 211.556 135.746 211.525 135.992C211.522 136.111 211.481 136.226 211.409 136.321C211.337 136.415 211.236 136.485 211.122 136.519V136.553L141.745 176.7L140.746 174.97L210.39 134.67Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.062 128.31C20.062 129.155 18.9273 129.836 17.5316 129.836C16.1359 129.836 15.0068 129.155 15.0068 128.31C15.0068 127.464 16.1415 126.783 17.5316 126.783C18.9216 126.783 20.062 127.481 20.062 128.31Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0507 84.3899H15.0068V128.236H20.0507V84.3899Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5316 85.9162C18.9291 85.9162 20.062 85.2329 20.062 84.39C20.062 83.5471 18.9291 82.8638 17.5316 82.8638C16.134 82.8638 15.0011 83.5471 15.0011 84.39C15.0011 85.2329 16.134 85.9162 17.5316 85.9162Z",
    fill: "#353535"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.762 198.209C141.762 199.054 140.627 199.735 139.231 199.735C137.836 199.735 136.707 199.054 136.707 198.209C136.707 197.364 137.841 196.683 139.231 196.683C140.621 196.683 141.762 197.364 141.762 198.209Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.745 154.272H136.701V198.118H141.745V154.272Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.762 154.278C141.762 155.118 140.627 155.804 139.231 155.804C137.836 155.804 136.707 155.118 136.707 154.278C136.707 153.438 137.841 152.746 139.231 152.746C140.621 152.746 141.762 153.433 141.762 154.278Z",
    fill: "#353535"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.322 45.4742C163.322 46.3196 162.187 47.0061 160.797 47.0061C159.407 47.0061 158.266 46.3196 158.266 45.4742C158.266 44.6288 159.401 43.948 160.797 43.948C162.193 43.948 163.322 44.6232 163.322 45.4742Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.31 1.52612H158.266V45.3721H163.31V1.52612Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.322 1.53188C163.322 2.37158 162.187 3.0581 160.797 3.0581C159.407 3.0581 158.266 2.37158 158.266 1.53188C158.266 0.692184 159.401 0 160.797 0C162.193 0 163.322 0.68651 163.322 1.53188Z",
    fill: "#353535"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.552 115.305C287.552 116.145 286.417 116.832 285.022 116.832C283.626 116.832 282.491 116.145 282.491 115.305C282.491 114.466 283.626 113.779 285.022 113.779C286.417 113.779 287.552 114.46 287.552 115.305Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.535 71.3689H282.491V115.215H287.535V71.3689Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.552 71.369C287.552 72.2144 286.417 72.8952 285.022 72.8952C283.626 72.8952 282.491 72.2144 282.491 71.369C282.491 70.5236 283.626 69.8428 285.022 69.8428C286.417 69.8428 287.552 70.5236 287.552 71.369Z",
    fill: "#353535"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.303 8.65796H157.279C156.853 8.65796 156.508 9.00342 156.508 9.42958V47.7778C156.508 48.2039 156.853 48.5494 157.279 48.5494H164.303C164.729 48.5494 165.075 48.2039 165.075 47.7778V9.42958C165.075 9.00342 164.729 8.65796 164.303 8.65796Z",
    fill: "#DBDBDB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1844_6843"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 300,
    height: 249.629,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFightRoom);
export default __webpack_public_path__ + "static/media/FightRoom.b9e26e71de87394df36f8f653fd01eb9.svg";
export { ForwardRef as ReactComponent };